export default __webpack_public_path__ + "static/media/toast-close-icon.415fb3e1.svg";